var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-content"},[_c('div',{attrs:{"id":"magazine"}},[_c('div',{class:("text" + _vm.index),staticStyle:{"height":"800px"},style:('background:#fff url('+_vm.item+');')})])])}
var staticRenderFns = []

export { render, staticRenderFns }